import { Application } from '../../entities/Application';

export function findBriefJobDetails(application: Application) {
  return application.candidate.applications.find(
    (app) => app.id === application.id,
  )?.job;
}
